<template>
  <error-layout>
    <div class="text-roxo mt-10">
      <h1 class="text-4xl font-bold mb-4">{{ $t('erro.mensagem') }}</h1>
      <p class="text-lg mb-6">{{ $t('erro.pagina') }}</p>
      <img src="@/assets/apps/404.png" alt="Página não encontrada" class="max-w-xs mx-auto" />
    </div>
  </error-layout>
</template>

<script>
import ErrorLayout from '@/templates/ErrorLayout.vue'

export default {
  name: 'NotFound',
  components: {
    ErrorLayout
  }
}
</script>
